module.exports = __webpack_public_path__ + "img/logoWhite.4960734.svg";